import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { useRoutes } from 'react-router-dom';
import { message } from 'antd';

import { routes } from './routes/index';

import { AuthProvider } from './providers/user-context';
import { toasterConfig } from './config/toaster.config';
import { queryClient } from './config/query-client';
import LanguageContextProvider from './contexts/Localization';

const App = () => {
  const element = useRoutes(routes);

  message.config({
    top: 40,
  });

  return (
    <QueryClientProvider client={queryClient}>
      <Toaster {...toasterConfig} />
      <LanguageContextProvider>
        <AuthProvider>{element}</AuthProvider>
      </LanguageContextProvider>
    </QueryClientProvider>
  );
};

export default App;
